var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.62917 2.9334C8.79167 2.7709 8.79167 2.50007 8.62917 2.3459L7.65417 1.3709C7.5 1.2084 7.22917 1.2084 7.06667 1.3709L6.3 2.1334L7.8625 3.6959M1.25 7.18756V8.75007H2.8125L7.42083 4.13757L5.85833 2.57507L1.25 7.18756Z",
    fill: "#9FA1A2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiPencil);
export default __webpack_public_path__ + "static/media/mdi-pencil.0225736b9da7166ca10104cc13b3aa67.svg";
export { ForwardRef as ReactComponent };